import { useEffect, useState } from "react";

export function useDebounced(value, delay, onSettled) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => {
      setDebounced(value);
      onSettled?.();
    }, delay);
    return () => clearTimeout(id);
  }, [value, delay, onSettled]);
  return debounced;
}
